import { cx } from "./cx";

/** The landing page's mark: a play button on an ink tile with the on-air dot. Inverted for dark backgrounds. */
export function LogoMark({ inverted, className }: { inverted?: boolean; className?: string }) {
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true" className={cx("size-7 shrink-0", className)}>
      <rect width="48" height="48" rx="12" fill={inverted ? "#ffffff" : "#18202c"} />
      <path d="M17 14.5 34 24 17 33.5Z" fill={inverted ? "#18202c" : "#ffffff"} />
      <circle cx="36" cy="12" r="5" fill="#e5322d" />
    </svg>
  );
}

export function Logo({ inverted }: { inverted?: boolean }) {
  return (
    <span className="flex items-center gap-2.5 font-display text-lg font-bold tracking-tight">
      <LogoMark inverted={inverted} />
      Superlivestream
    </span>
  );
}
